module.exports = __webpack_public_path__ + "img/Mb_Lobby_Video.a41c587d.jpg";